import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDelete = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M8 25.333c0 1.467 1.2 2.667 2.667 2.667h10.667c1.467 0 2.667-1.2 2.667-2.667v-13.333c0-1.467-1.2-2.667-2.667-2.667h-10.667c-1.467 0-2.667 1.2-2.667 2.667v13.333zM24 5.333h-3.333l-0.947-0.947c-0.24-0.24-0.587-0.387-0.933-0.387h-5.573c-0.347 0-0.693 0.147-0.933 0.387l-0.947 0.947h-3.333c-0.733 0-1.333 0.6-1.333 1.333s0.6 1.333 1.333 1.333h16c0.733 0 1.333-0.6 1.333-1.333s-0.6-1.333-1.333-1.333z" })
});
export default SvgDelete;
